// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-298f0528] .p-sortable-column-icon{margin:0 0 0 0!important}button[data-v-298f0528]{margin:0 2px}.pendente[data-v-298f0528]{color:#1f2d3d;background-color:#ffc107;font-weight:700}.ativa[data-v-298f0528]{background-color:#007bff}.ativa[data-v-298f0528],.cancelada[data-v-298f0528]{color:#fff;font-weight:700}.cancelada[data-v-298f0528]{background-color:#dc3545}.quitada[data-v-298f0528]{color:#fff;background-color:#28a745;font-weight:700}", ""]);
// Exports
module.exports = exports;
